import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles from 'component/utils/DatatableStyles'

const paginationOptions = {
    rowsPerPageText: "Show Per Page:", 
    rangeSeparatorText: "dari",
  };

const Datatables = ({data, onEditMenu, onDeleteMenu}) => {
    const [search, setSearch] = useState("");

    const formattedData = data.map((item, index) => ({
      id: index + 1,
      ...item
    })).sort((a, b) => a.menu_id - b.menu_id);;

    const filteredData = formattedData.filter((item) =>
      [item?.menu_desc, item?.file_name, item?.brand_id, item?.menu_path]
        .some((field) => field?.toString().toLowerCase().includes(search.toLowerCase()))
    );

    const columns = [
      { 
        name: "ID", 
        selector: (row) => row.menu_id, 
        maxWidth: '70px', 
        style: { display: "flex", justifyContent: "center", alignItems: "center" }, 
        sortable: true 
      },
      { 
        name: "Menu", 
        selector: (row) => row.menu_desc, 
        minWidth: "120px", 
        grow: 2, 
        sortable: true 
      },
      { 
        name: "File Name", 
        selector: (row) => row.file_name, 
        minWidth: "120px", 
        grow: 1, 
        sortable: true 
      },
      { 
        name: "Path", 
        selector: (row) => row.menu_path, 
        minWidth: "120px", 
        maxWidth: "250px" 
      },
      { 
        name: "Brand", 
        selector: (row) => row.brand_id, 
        minWidth: "100px", 
        maxWidth: "150px" 
      },
      { 
        name: "Icon", 
        selector: (row) => row.menu_icon, 
        minWidth: "100px", 
        cell: (row) => <i className={row.menu_icon}></i> 
      },
      { 
        name: "Action", 
        minWidth: "120px", 
        maxWidth: "250px", 
        style: { display: "flex", justifyContent: "center", alignItems: "center" },
        cell: (row) => (
          <div>
            <button 
              className="btn btn-sm rounded-circle btn-warning me-2"
              onClick={() => onEditMenu(row)}
            >
              <i className='bx bx-edit' style={{color:"white"}}></i>
            </button>

            <button 
              className="btn btn-sm rounded-circle btn-danger"
              onClick={() => onDeleteMenu(row)}
            >
              <i className='bx bx-trash'></i>
            </button>
          </div>
        )
      }
    ];

  return (
    <div class="col-lg-12 mb-4">
        <div class="d-flex justify-content-start align-items-center mb-2">
                <input
                type="text"
                placeholder="Search..."
                class="form-control w-100"
                style={{ maxWidth: "200px" }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                />
        </div>

        <div class="datatable-container">
            <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover={false}
            customStyles={DatatableStyles}
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 25]}
            paginationComponentOptions={paginationOptions}
            responsive
            />
        </div>
    </div>
  );
};

export default Datatables;
